/**
 * @flow
 * @file Creates an API Context
 * @author Box
 */
import React from 'react';
import API from '../../../api';

export default React.createContext<?API>();
